<template>
  <div>
    <v-sheet class="py-4 py-md-6" color="primary">
      <TitleWidget dark>
        {{ item.title || title }}
      </TitleWidget>
    </v-sheet>

    <v-container class="pt-0 pt-md-6 pb-10 pb-md-13 pb-lg-16 item">
      <v-row justify="center" no-gutters>
        <v-col cols="12" md="9">
          <img
            v-if="item.img"
            @error="onError"
            class="d-block mt-6"
            loading="lazy"
            :src="files + item.img + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
            :alt="item.title"
            width="100%"
          />

          <div
            v-if="item.text || item.introduction"
            class="
              grey--text
              text--darken-2 text-subtitle-1
              font-weight-light
              mt-6
              item-text
              ck-content
            "
          >
            <span
              class="font-secondary"
              v-html="item.text || item.introduction"
            ></span>
          </div>
        </v-col>
      </v-row>

      <div id="missao-visao-valores">
        <v-row v-if="mission.title" justify="center">
          <v-col class="mt-12" cols="12" md="6">
            <DifferentialCard v-bind="mission" />
          </v-col>
        </v-row>

        <v-row v-if="vision.title" justify="center">
          <v-col :class="mission.title ? 'mt-6' : 'mt-12'" cols="12" md="6">
            <DifferentialCard v-bind="vision" />
          </v-col>
        </v-row>

        <v-row v-if="values.title" justify="center">
          <v-col
            :class="mission.title || vision.title ? 'mt-6' : 'mt-12'"
            cols="12"
            md="6"
          >
            <DifferentialCard v-bind="values" />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import DifferentialCard from "../components/cards/DifferentialCard.vue";
import DefaultImg from "../assets/img/default-img.png";

const _config = {
  mod: "about",
};

const _data = {
  title: "Quem Somos",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    mission() {
      return this.$rest("about-mission").item;
    },
    vision() {
      return this.$rest("about-vision").item;
    },
    values() {
      return this.$rest("about-values").item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    onError(e) {
      e.target.src = DefaultImg;
    },
    hash() {
      if (this.$route.path === "/missao-visao-valores") {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const el = document.getElementById(this.$route.path.replace("/", ""));

          if (el) {
            window.scrollTo({
              top: el.offsetTop + (!this.smAndDown ? 180 : 0),
              behavior: "smooth",
            });
          }
        }, 0);
      }
    },
  },
  watch: {
    $route() {
      this.hash();
    },
  },
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });

    this.$rest("about-mission").get({
      save: (state, data) => (state.item = data),
    });

    this.$rest("about-vision").get({
      save: (state, data) => (state.item = data),
    });

    this.$rest("about-values").get({
      save: (state, data) => (state.item = data),
    });
  },
  beforeUpdate() {
    setTimeout(() => {
      this.hash();
    }, 1000);
  },
  components: {
    TitleWidget,
    DifferentialCard,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-text {
    line-height: 1.6;
  }
}
</style>
